import styled from '@emotion/styled';

const ConfirmationButtonWrap = styled('div')({
  height: '5rem',
  margin: '3.5rem auto',
  width: '10em',
});

export default ConfirmationButtonWrap;
